import { render } from "./HeroiconsSolidQrcode.vue?vue&type=template&id=26524eb4"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidQrcode.vue"]])

export default __exports__